import Icon from "@mui/icons-material/Handshake";
import { ProjectKarzanList } from "./ProjectKarzanList";
import { ProjectKarzanCreate } from "./ProjectKarzanCreate";
import { ProjectKarzanEdit } from "./ProjectKarzanEdit";
import { ProjectKarzanShow } from "./ProjectKarzanShow";

export default {
  list: ProjectKarzanList,
  create: ProjectKarzanCreate,
  edit: ProjectKarzanEdit,
  show: ProjectKarzanShow,
  icon: Icon,
  label: "Karzan",
  options: { label: "Karzan" },
  name: "projectKarzans",
};
